import { DefaultBackFinishButtons, DefaultBackNextButtons, DefaultNextButtons, GuidedTour } from "@common/lib/guided-tour/guided-tour.service";
import { CommonTourSteps } from "./common-tour-steps";

export const PurposeStatementTour: GuidedTour = {
    steps: [CommonTourSteps.openOrgMenuToShowSidebarNavNodeStep("Purpose answers", "Purpose & Vision"), {
        waitForAndAttachToElementSelector: "adapt-display-link-hierarchy adapt-display-navigation-node span",
        elementSelectorTextContent: "Purpose & Vision", // looking for <adapt-display-navigation-node> with span content of this text
        advanceOnAttachedElementEvent: "click",
        attachTo: {
            on: "bottom-end",
        },
        title: `Access purpose & vision`,
        text: `<p>Your organisation's Purpose statement answers are available here.</p>
        <p><b>Click on it now</b> to show it.</p>`,
        modalOverlayOpeningPadding: 3,
    }, {
        title: "See purpose statement answers",
        text: "Here are the answers you just provided.",
        canClickTarget: false,
        waitForAndAttachToElementSelector: `[data-tour="purpose-statement-card"]`,
        attachTo: {
            on: "bottom",
        },
        buttons: DefaultNextButtons,
    }, {
        title: "Edit purpose statement answers",
        text: "In the future, you can edit your Purpose statement answers using this option, which will run you through the pathway again.",
        canClickTarget: false,
        waitForAndAttachToElementSelector: `[data-tour="purpose-statement-edit"]`,
        attachTo: {
            on: "bottom",
        },
        buttons: DefaultBackNextButtons,
    }, {
        title: "Continue",
        text: `<p>You can continue your journey by going to your <b>Personal Dashboard</b>.</p>`,
        waitForAndAttachToElementSelector: `[id="sidebar-personal"]`,
        attachTo: {
            on: "right",
        },
        buttons: DefaultBackFinishButtons,
    }],
};
